import { useEffect } from "react";
import NiceModal from "@ebay/nice-modal-react";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { useHistory } from "react-router-dom";
import { CONVERSTAION } from "../../../navigation/Constants";
import { useDispatch, useSelector } from "react-redux";
import { getMyMemberDetails } from "../../../services/memberService";
import { RootState } from "../../../redux/store";
import { setUserData } from "../../../redux/member";

declare global {
  interface Window {
    Webflow: any;
  }
}

const Actions = ({
  handleBlockMember,
  complaintAboutMember,
  matchType,
  hideChat,
  isChatScreen,
}: any) => {
  const dispatch = useDispatch();
  const member = useSelector((state: RootState) => state.member);
  useEffect(() => {
    window.Webflow.destroy();
    window.Webflow.ready();
  }, []);

  const blockAndHideChat = async (modalHeaderTitle: string) => {
    handleBlockMember(modalHeaderTitle);
    hideChat();
  };

  const blockMember = () => {
    closeActionsDropdown();
    NiceModal.show("action_modal", {
      onNext: () => blockAndHideChat("החסימה הצליחה"),
      headerTitle: "רוצה לחסום את הפרופיל הזה?",
      contentTitle:
        "משתמשים חסומים לא יוכלו לצפות בפרופיל שלך או לשלוח לך הודעות",
      seconderyButtonText: "בעצם לא",
      primaryButtonText: "כן, לחסום",
      showCloseButton: true,
      showSeconderyButton: true,
    });
  };

  const deleteChat = () => {
    closeActionsDropdown();
    NiceModal.show("action_modal", {
      onNext: hideChat,
      headerTitle: "מחק שיחה",
      contentTitle: "?האם את/ה בטוח/ה",
      seconderyButtonText: "בעצם לא",
      primaryButtonText: "מחק",
      showCloseButton: true,
      showSeconderyButton: true,
    });
  };

  const cancelDoubleMatch = () => {
    closeActionsDropdown();
    NiceModal.show("action_modal", {
      onNext: () => blockAndHideChat("ההתאמה בוטלה"),
      headerTitle: "בטל התאמה",
      contentTitle: "לא תוכלו לראות או לדבר עוד אחד עם השני.",
      seconderyButtonText: "בעצם לא",
      primaryButtonText: "בטל התאמה",
      showCloseButton: true,
      showSeconderyButton: true,
    });
  };

  const openComplaintOnMemberModal = () => {
    closeActionsDropdown();
    NiceModal.show("reportMember_modal", {
      onNext: complaintAboutMember,
      headerTitle: "דווח על משתמש",
      contentTitle: "לא תוכלו לראות או לדבר עוד אחד עם השני.",
      seconderyButtonText: "בעצם לא",
      primaryButtonText: "דווח",
    });
  };

  const closeActionsDropdown = () => {
    let element = document.getElementById("profile_action_dropdown");
    element?.dispatchEvent(new Event("w-close", { bubbles: true }));
  };

  return (
    <div
      data-hover="false"
      data-delay={0}
      className="my_menu w-clearfix w-dropdown"
    >
      <div
        id="profile_action_dropdown"
        className="my_menu_button w-dropdown-toggle"
      />
      <nav className="my_menu_list w-dropdown-list">
        <a
          href="#"
          onClick={blockMember}
          className="my_menu_link w-dropdown-link"
        >
          חסימה
        </a>
        {!matchType ? (
          <a
            href="#"
            onClick={cancelDoubleMatch}
            className="my_menu_link w-dropdown-link"
          >
            ביטול התאמה
          </a>
        ) : matchType === 3 ? (
          <a
            href="#"
            onClick={cancelDoubleMatch}
            className="my_menu_link w-dropdown-link"
          >
            ביטול התאמה
          </a>
        ) : null}
        <a
          href="#"
          onClick={openComplaintOnMemberModal}
          className="my_menu_link w-dropdown-link"
        >
          דיווח
        </a>
        {isChatScreen && (
          <a
            href="#"
            onClick={deleteChat}
            className="my_menu_link w-dropdown-link"
          >
            מחיקת שיחה
          </a>
        )}
      </nav>
    </div>
  );
};

export default Actions;
